import React, { useState } from 'react';
import axios from 'axios';
import { baseurl } from '../../utility/helper';

const FileUpload = ({setFileUploded}) => {
  const [files, setFiles] = useState([]);
  const [response, setResponse] = useState(null);

  // Get candidateId from sessionStorage and parse as int
  const candidateId = parseInt(sessionStorage.getItem("CandidateID")) || null;

  const handleFileChange = (e) => {
    setFiles(e.target.files);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!candidateId) {
      alert("Candidate ID is missing.");
      return;
    }

    if (files.length === 0) {
      alert("Please select at least one file.");
      return;
    }

    const formData = new FormData();
    for (let file of files) {
      formData.append('files', file);
    }

    const url = `${baseurl}/PriorEvidence/upload?candidateId=${candidateId}`;

    try {
      const res = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setResponse(res.data.message);

      if (res.data.files) {
        alert('Upload successful. Ratification will take one month.');
        setFileUploded(true);
      } else {
        alert('Upload response missing files data');
      }
    } catch (error) {
      console.error('Upload failed: Please check file', error);
      alert('Upload failed Please check file Size Min 1 MB');
    }
  };

  return (
    <div>
      <h2>Upload Multiple Files</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="file"
          name="files"
          multiple
          onChange={handleFileChange}
        />
        <br /><br />
        <button type="submit">Upload</button>
      </form>

      {response && (
        <div style={{ marginTop: '20px' }}>
          <h4>Upload Status:</h4>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
